module.exports = __webpack_public_path__ + "53641ebb36ebecfe2f190d5ece891d50.svg";